module.exports = __webpack_public_path__ + "img/SB.bba86765.png";